import { atomFamily } from "recoil";

export const dialogAtomFamily = atomFamily({
	key: "dialogAtomFamily",
	default: false,
});
